import React, { useState } from 'react'
import { Link, useNavigate,  } from 'react-router-dom';
export default function Login() {
  let navigate = useNavigate();
  const [credentials, setcredentials] = useState({
    password: "",
    email: "",
  });
  const onChange = (e) => {
    setcredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(
      JSON.stringify({
        email: credentials.email,
        password: credentials.password,
      })
    );
    const response = await fetch("https://nom-nom-backend.vercel.app/api/login", {
      method: "POST",
      withCredentials:"true",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: credentials.email,
        password: credentials.password,
      }),
    });
    const json = await response.json();
    console.log(json);
    if (!json.success) {
      alert("enter valid credentials");
    }
    if(json.success){
      localStorage.setItem('authToken', json.authToken);
      console.log(localStorage.getItem('authToken'));
      navigate('/');
    }
  };
  return (
    <div>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={credentials.email}
              placeholder="Enter Email"
              onChange={onChange}
            />
            <small id="emailHelp" className="form-text text-muted">
              We'll never share your email with anyone else.
            </small>
          </div>
          <div className="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              placeholder="Password"
              onChange={onChange}
            />
          </div>
          <button type="submit" className="btn m-3 btn-success">
            Submit
          </button>
          <Link to="/create-user" className="btn btn-danger m-3">
            Not a existing user?
          </Link>
        </form>
      </div>
    </div>
  )
}
